module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('row', [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-aqua",
      "bgIcon": "ion ion-ios-gear-outline",
      "text": "CPU TRAFFIC",
      "number": "90",
      "numberType": "percentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-red",
      "bgIcon": "fa fa-google-plus",
      "text": "LIKES",
      "number": "41,410"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-green",
      "bgIcon": "ion ion-ios-cart-outline",
      "text": "SALES",
      "number": "760"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-yellow",
      "bgIcon": "ion ion-ios-people-outline",
      "text": "NEW MEMBERS",
      "number": "2,000"
    }
  })], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('va-direct-chat', {
    attrs: {
      "theme": "primary",
      "talkList": [],
      "contacts": [],
      "title": "Direct Chat",
      "badgeCount": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-user-list')], 1)])], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('va-info-box', {
    attrs: {
      "wrapBgColor": "bg-yellow",
      "bgIcon": "ion ion-ios-pricetag-outline",
      "text": "Inventory",
      "number": "5200",
      "isProgress": true,
      "numberType": "comma",
      "progressDescription": "50% Increase in 30 Days",
      "percentage": 50
    }
  }), _vm._v(" "), _c('va-info-box', {
    attrs: {
      "wrapBgColor": "bg-green",
      "bgIcon": "ion ion-ios-pricetag-outline",
      "text": "Mentions",
      "number": "92050",
      "isProgress": true,
      "numberType": "comma",
      "progressDescription": "20% Increase in 30 Days",
      "percentage": 20
    }
  }), _vm._v(" "), _c('va-info-box', {
    attrs: {
      "wrapBgColor": "bg-red",
      "bgIcon": "ion ion-ios-pricetag-outline",
      "text": "Downloads",
      "number": "114381",
      "numberType": "comma",
      "isProgress": true,
      "progressDescription": "70% Increase in 30 Days",
      "percentage": 70
    }
  }), _vm._v(" "), _c('va-info-box', {
    attrs: {
      "wrapBgColor": "bg-aqua",
      "bgIcon": "ion ion-ios-pricetag-outline",
      "text": "Direct Messages",
      "number": "163921",
      "numberType": "comma",
      "isProgress": true,
      "progressDescription": "40% Increase in 30 Days",
      "percentage": 40
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b844b764!./~/vue-loader/lib/selector.js?type=template&index=0!./src/examples/Dashboard.v2.vue
// module id = 536
// module chunks = 1